import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ToastContainerDirective } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { AtlasToastService } from './atlas-toast.service';

export enum SmsAdvErrorType {
  CREATE_ERROR,
  UPDATE_ERROR
}

export enum SmsAdvDirectionTab {
  FORWARD,
  BACK,
  JUMP_SELECT_RECIPIENT,
  JUMP_CREATE_CAMPAIGN
}

@Injectable()
export class SmsAdvCreateTabHandlerService {
  private currentTab = 1;
  private changeTab = new Subject<number>();
  private closeTab = new Subject<number>();
  private completeTabBS = new BehaviorSubject<any>(false);
  private backTabBS = new BehaviorSubject<number>(0);
  private tabFormData = new Observable<any>();

  get tab(): number {
    return this.currentTab;
  }

  get changeTab$(): Observable<any> {
    return this.changeTab.asObservable();
  }

  get closeTab$(): Observable<any> {
    return this.closeTab.asObservable();
  }

  get tabCompleted$(): Observable<any> {
    return this.completeTabBS.asObservable();
  }

  get tabFormData$(): Observable<any> {
    return this.tabFormData;
  }

  get backTab$(): Observable<any> {
    return this.backTabBS.asObservable();
  }

  // close current tab
  setCloseTab() {
    this.closeTab.next(this.currentTab);
  }

  setBackTab() {
    this.backTabBS.next(this.currentTab);
  }

  // current tab has done all operation
  setTabIsCompleted(value?) {
    if (value) {
      this.completeTabBS.next(value);
    } else {
      this.completeTabBS.next(true);
    }
  }
  // set current tab on based direction
  setChangeTab(direction: SmsAdvDirectionTab) {
    switch (direction) {
      case SmsAdvDirectionTab.FORWARD:
        this.currentTab++;
        break;
      case SmsAdvDirectionTab.BACK:
        this.currentTab--;
        break;
      case SmsAdvDirectionTab.JUMP_SELECT_RECIPIENT:
        this.currentTab = 1;
        break;
      case SmsAdvDirectionTab.JUMP_CREATE_CAMPAIGN:
        this.currentTab = 2;
        break;
    }
    this.changeTab.next(this.currentTab);
  }

  saveTabFormData(obs) {
    this.tabFormData = obs;
  }

  valuesForm$(form: UntypedFormGroup): Observable<any> {
    const data = form.value;
    return of(data);
  }

  of$(data) {
    return of(data);
  }

  constructor(private atlasToast: AtlasToastService) {}

  handlerErrorMsfg(errorType: SmsAdvErrorType, error, toastContainer: ToastContainerDirective) {
    switch (errorType) {
      case SmsAdvErrorType.CREATE_ERROR:
        return this.atlasToast.error('common_error', null, 6000, toastContainer);
    }
  }

  handlerSuccessMsg() {
    return this.atlasToast.success('common_success', null);
  }
}
